import React from "react";
import { Layout } from "antd";
import { FlowStationCapcitySettings } from "./FlowstationCapcitySettings";
import { FlowstationCapacity } from "./FlowstationCapacity";
import { FlowstationCapacityDialog } from "./FlowstationCapacityDialog";

const { Content, Sider } = Layout;
export const FlowstationCapacityBaseview = () => {
  return (
    <Layout>
      <Content>
        <Layout style={{ background: "#fff" }}>
          <Sider
            width={"70%"}
            style={{ background: "#fff", paddingLeft: "20px", width: "30%" }}
          >
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row ">
                <div className="ms-Grid-col ms-sm12">
                  {" "}
                  <FlowstationCapacity />
                </div>
              </div>
            </div>
          </Sider>
          <Content>
            <FlowStationCapcitySettings />
            <FlowstationCapacityDialog />
          </Content>
        </Layout>
      </Content>
    </Layout>
  );
};

